<fa-icon *ngIf="iconName" [icon]="iconName"></fa-icon>
<span class="text-truncate mat-caption"><ng-content></ng-content></span>
